import React from 'react';
import moment from 'moment';
import { IJob } from '../../JobModels';
import { Grid, SvgIcon } from '@material-ui/core';
import { Colors } from '../../../../constants';
import { Text } from 'library';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { StyleSheet, css } from 'aphrodite';

interface IProps {
    job: null | IJob;
    noMargin?: boolean;
}

export default function JobDays({ job, noMargin }: IProps) {
    const getDates = () => {
        let start = moment(job?.start_date);
        let end = moment(job?.end_date);
        if (job?.ongoing) {
            return job?.start_date
                ? `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`
                : `Starting ${job?.start_month}`;
        } else {
            let overnight = start.diff(end, 'days');
            return `${start.format('ddd, MMM D, YYYY')}${overnight ? ' - ' + end.format('ddd, MMM D, YYYY') : ''}`;
        }
    };

    const getSingleTime = (startTime: any, endTime: any) => {
        let start = moment(startTime).format('h:mma');
        let end = moment(endTime, 'HH:mm:ss').format('h:mma');

        return `${start}-${end}`;
    };

    const getSingleRow = () => {
        const times = getSingleTime(job?.start_date_time, job?.end_time);

        return job ? (
            <Grid container item style={{ paddingTop: 12, paddingBottom: 12 }}>
                <Grid item>
                    <div
                        style={{
                            backgroundColor: Colors.lightTurq,
                            height: 26,
                            width: 26,
                            borderRadius: 13,
                        }}
                    >
                        <SvgIcon component={ScheduleIcon} viewBox="-2 0 26 26" style={{ color: Colors.darkNavy }} />
                    </div>
                </Grid>
                <Grid item style={{ paddingLeft: 12 }}>
                    <Text variant="body1">{times}</Text>
                </Grid>
            </Grid>
        ) : null;
    };

    const getDayRow = () => {
        let orderedDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return (
            <>
                {job?.days_of_week ? (
                    <Grid container direction="row" style={{ marginTop: 12, marginBottom: 12 }}>
                        {orderedDays.map((day) => (
                            <Grid
                                container
                                item
                                key={day}
                                className={css(
                                    job?.days_of_week.includes(day) ? [styles.day, styles.selected] : styles.day,
                                )}
                            >
                                <Text bold variant="body2">
                                    {day[0]}
                                </Text>
                            </Grid>
                        ))}
                    </Grid>
                ) : null}
            </>
        );
    };

    return (
        <Grid>
            <Grid style={{ flexDirection: 'row', marginTop: noMargin ? 0 : 20, justifyContent: 'space-between' }}>
                <Grid container item>
                    <Grid item>
                        <Text bold variant="body1">
                            {getDates()}
                        </Text>
                    </Grid>
                </Grid>
            </Grid>
            {job?.ongoing && job?.long_term && !job?.end_date && <Text variant="body1">At least 6 months long</Text>}
            {!job?.ongoing && !!job && getSingleRow()}
            {job?.ongoing && getDayRow()}
        </Grid>
    );
}

const styles = StyleSheet.create({
    day: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 25,
        height: 25,
        marginRight: 6,
    },
    selected: {
        backgroundColor: Colors.lightTurq,
        borderColor: Colors.darkNavy,
        borderRadius: 13,
        borderWidth: 0.5,
        borderStyle: 'solid',
    },
});
